import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./components/AuthContext";
import Dashboard from "./components/Dashboard";
import LoginPage from "./components/LoginPage";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import UsersPage from "./components/UsersPage";
import UserConfigPage from "./components/UserConfigPage";
import UserStatsPage from "./components/UserStatsPage";
import AdminPanel from "./components/AdminPanel";
import MessagesPage from "./components/MessagesPage";
import HighScoresPage from "./components/HighScoresPage";
import SubscriptionPage from "./components/SubscriptionPage";
import AdminMonetizationPage from "./components/AdminMonetizationPage";
import UserProfilePage from "./components/UserProfilePage";
import MusicPage from "./components/MusicPage";
import BacktestPage from "./components/BacktestPage";
import TaxPage from "./components/TaxPage";
import ChangelogPage from "./components/ChangelogPage";
import AboutPage from "./components/AboutPage";
import PrivacyPage from "./components/PrivacyPage";
import TermsPage from "./components/TermsPage";
import FaqPage from "./components/FaqPage";
import ContactPage from "./components/ContactPage";
import DisclaimerPage from "./components/DisclaimerPage";
import CookiePolicyPage from "./components/CookiePolicyPage";
import SellAuditPage from "./components/SellAuditPage";
import TradeTimelinePage from "./components/TradeTimelinePage";

import AssistantChat from "./components/AssistantChat";
import WhatsNewCard from "./components/WhatsNewCard";

// Router component that checks for session_id in URL fragment
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id synchronously (prevents race conditions)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/users" 
        element={
          <ProtectedRoute>
            <UsersPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/traders" 
        element={
          <ProtectedRoute>
            <UsersPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/config" 
        element={
          <ProtectedRoute>
            <UserConfigPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/stats" 
        element={
          <ProtectedRoute>
            <UserStatsPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/diag/sell-audit" 
        element={
          <ProtectedRoute>
            <SellAuditPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/timeline" 
        element={
          <ProtectedRoute>
            <TradeTimelinePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/messages" 
        element={
          <ProtectedRoute>
            <MessagesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/highscores" 
        element={
          <ProtectedRoute>
            <HighScoresPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/subscription" 
        element={
          <ProtectedRoute>
            <SubscriptionPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/monetization" 
        element={
          <ProtectedRoute>
            <AdminMonetizationPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/profile/:userId" 
        element={
          <ProtectedRoute>
            <UserProfilePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/music" 
        element={
          <ProtectedRoute>
            <MusicPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/backtest" 
        element={
          <ProtectedRoute>
            <BacktestPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/tax" 
        element={
          <ProtectedRoute>
            <TaxPage />
          </ProtectedRoute>
        } 
      />
      <Route path="/changelog" element={<ChangelogPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/disclaimer" element={<DisclaimerPage />} />
      <Route path="/cookies" element={<CookiePolicyPage />} />
      <Route path="/cookie-policy" element={<CookiePolicyPage />} />
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark" style={{ position: 'relative', minHeight: '100vh', backgroundColor: '#000000' }}>
      <div style={{ position: 'relative', zIndex: 1 }}>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <AssistantChat />
            <WhatsNewCard />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
